import { createAsyncThunk } from "@reduxjs/toolkit";
import { type RegisterInternalDeliveryParams } from "../../../domain/entities/compliance";
import { type ComplianceDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";
import { getCase } from "./get-case";

/**
 * Registers the delivery Operations made itself and reloads the case (DMS-28),
 * so the pill in the header and the history entry the backend just wrote both
 * come from the server rather than from what the screen guessed.
 */
export const registerInternalDelivery = createAsyncThunk<
  void,
  RegisterInternalDeliveryParams,
  { dispatch: ComplianceDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.REGISTER_INTERNAL_DELIVERY, async (params, { dispatch, extra }) => {
  await extra.complianceRepo.registerInternalDelivery(params);
  await dispatch(getCase({ requestId: params.requestId }));
});
